import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import "./SignupCommon.css";
import planApproveIcon from "../../assets/images/plan-approve-tick.png";
import checkoutGraph from "../../assets/images/checkout-graph.png";
import locationIcon from "../../assets/images/location-icon.png";
import prescriptionIcon from "../../assets/images/prescription.png";
import starIcon from "../../assets/images/star.png";
import weightLossIcon from "../../assets/images/weightloss.png";
import reviewImg1 from "../../assets/images/review-img1.png";
import reviewImg2 from "../../assets/images/review-img2.png";
import reviewImg3 from "../../assets/images/review-img3.png";
import reviewImg4 from "../../assets/images/review-img4.png";
import reviewImg5 from "../../assets/images/review-img5.png";
import reviewImg6 from "../../assets/images/review-img6.png";
import reviewImg7 from "../../assets/images/review-img7.png";
import reviewImg8 from "../../assets/images/review-img8.png";
import arrowRight from "../../assets/images/arrow-right-blue.png";
import arrowLeft from "../../assets/images/arrow-left-blue.png";
import arrow from "../../assets/images/arrow.png";

const SignupPage19: React.FC = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState<string | null>(null);
  const [state, setState] = useState<string | null>(null);
  const [currentWeight, setCurrentWeight] = useState<string | null>(null);
  const [idealWeight, setIdealWeight] = useState<string | null>(null);
  const [lostWeight, setLostWeight] = useState<number | null>(null);
    const [weights, setWeights] = useState({
      currentWeight: 0,
      idealWeight: 0,
      firstInterval: 0,
      secondInterval: 0,
      thirdInterval: 0,
    });

      const nextChargeDate = new Date();
      nextChargeDate.setMonth(nextChargeDate.getMonth() + 1); // Add 1 month
      // Get today's date
      const today = new Date();
      const futureDate = new Date(today);
      futureDate.setDate(today.getDate() + 150);

      const options: Intl.DateTimeFormatOptions = {
        month: "long", // Use 'long' for full month name
        day: "numeric", // Day as a number
      };

      const futureDateValue = futureDate.toLocaleString("en-US", options);

    const desktopImages = [
      reviewImg1,
      reviewImg2,
      reviewImg3,
      reviewImg4,
      reviewImg5,
      reviewImg6,
      reviewImg7,
      reviewImg8,
    ];
    const mobileImages = [
      reviewImg1,
      reviewImg2,
      reviewImg3,
      reviewImg4,
      reviewImg5,
      reviewImg6,
    ];
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);
  const images = isMobile ? mobileImages : desktopImages;


   // Detect screen size on mount and resize
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 500);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);


      // Determine how many images to show based on screen size
      const imagesPerView = isMobile ? 1 : 4;
      const start = currentIndex * imagesPerView;
      const currentImages = images.slice(start, start + imagesPerView);

      // Scroll logic for desktop
      useEffect(() => {
        if (containerRef.current) {
          containerRef.current.scrollTo({
            left: containerRef.current.offsetWidth * currentIndex,
            behavior: "smooth",
          });
        }
      }, [currentIndex]);

      // Navigation functions
      const goToPrevious = () => {
        setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
      };

      const goToNext = () => {
        setCurrentIndex((prevIndex) =>
          Math.min(prevIndex + 1, Math.ceil(images.length / imagesPerView) - 1)
        );
      };

    useEffect(() => {
      const storedFirstName = localStorage.getItem("firstName");
      const storedState = localStorage.getItem("fullState");
      const storedCurrentWeight = localStorage.getItem("weight");
      const storedIdealWeight = localStorage.getItem("idealWeight");

      // Safely parse and set state
      setFirstName(storedFirstName ? JSON.parse(storedFirstName).value : null);
      setState(storedState ? JSON.parse(storedState).value : null);
      setCurrentWeight(
        storedCurrentWeight ? JSON.parse(storedCurrentWeight).value : null
      );
      setIdealWeight(
        storedIdealWeight ? JSON.parse(storedIdealWeight).value : null
      );

      // Calculate lost weight if both weights are available
      if (storedCurrentWeight && storedIdealWeight) {
        const current = parseFloat(JSON.parse(storedCurrentWeight).value);
        const ideal = parseFloat(JSON.parse(storedIdealWeight).value);
        setLostWeight(current - ideal);
      }
    }, []);


      useEffect(() => {
        if (currentWeight && idealWeight) {
          const current = parseFloat(currentWeight);
          const ideal = parseFloat(idealWeight);
          setWeights(() => {
            const difference = current - ideal;
            const intervalSize = Math.floor(difference / 4);

            return {
              currentWeight: Math.floor(current),
              idealWeight: Math.floor(ideal),
              firstInterval: Math.floor(current - intervalSize),
              secondInterval: Math.floor(current - 2 * intervalSize),
              thirdInterval: Math.floor(current - 3 * intervalSize),
            };
          });
        }
      }, [currentWeight, idealWeight]);
  const handleNext = () => {
    localStorage.setItem("step-13b-completed", "true");
  };
  useEffect(() => {
    const step13Completed = localStorage.getItem("step-13-completed");
    if (step13Completed) {
      navigate("/getting-started/step-13b",{ replace: true });
    } else {
      navigate("/getting-started/step-13",{ replace: true });
    }
  }, []);
  const isVariant = localStorage.getItem("isVariant") === "true";
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <div className="checkout-container">
          <div className="page-container">
            <div className="plan-approved-container">
              <img src={planApproveIcon} alt="tick" className="tick-icon" />
              <span className="plan-approved-content">
                Your plan has been approved
              </span>
            </div>
          </div>
          <div
            style={{
              textAlign: "center",
            }}
          >
            {!isVariant ? (
              <span className="content-for-client">
              {firstName},{" "}
              <span
                className="content-for-client"
                style={{ fontWeight: "500" }}
              >
                we can help you lose up to
              </span>{" "}
              {lostWeight} pounds by {futureDateValue}!
            </span>
            ) : (
              <span className="content-for-client">
                <span
                  className="content-for-client"
                  style={{ fontWeight: "500" }}
                >
                  we can help you lose up to
                </span>{" "}
                {lostWeight} pounds by {futureDateValue}!
              </span>
            )}
          </div>
          <div
            className="checkout-graph"
            style={{ position: "relative", display: "inline-block" }}
          >
            <img
              src={checkoutGraph}
              alt="Graph"
              className="graph-image"
              style={{ width: "100%", height: "auto" }}
            />

            {/* Example of overlaying text */}
            <div className="graph-first-interval">{weights.firstInterval}</div>
            <div className="graph-second-interval">
              {weights.secondInterval}
            </div>
            <div className="graph-third-interval">{weights.thirdInterval}</div>
            <div className="graph-final-interval">{weights.idealWeight}</div>
          </div>
          <Link to="/getting-started/step-14">
            <button onClick={handleNext} className="next-btn sticky-btn">
              Next
              <img src={arrow} alt="Arrow" style={{ marginLeft: "8px" }} />
            </button>
          </Link>
          <div className="tile-main-div" style={{ marginTop: "-90px" }}>
            <div className="shipping-tile">
              <div className="tile-styling">
                <div className="icon-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="36"
                    viewBox="0 0 35 36"
                    fill="none"
                  >
                    <circle
                      cx="17.5"
                      cy="18.1396"
                      r="17.25"
                      stroke="#AF71AF"
                      strokeWidth="0.5"
                    />
                    <image
                      href={locationIcon}
                      x="8"
                      y="8"
                      width="20"
                      height="20"
                    />
                  </svg>
                </div>
                <div className="tile-font">
                  FREE overnight shipping to{" "}
                  <span className="checkout-highlight">{state}</span>
                </div>
              </div>

              <div className="tile-styling">
                <div className="icon-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="36"
                    viewBox="0 0 35 36"
                    fill="none"
                  >
                    <circle
                      cx="17.5"
                      cy="18.1396"
                      r="17.25"
                      stroke="#AF71AF"
                      strokeWidth="0.5"
                    />
                    <image
                      href={prescriptionIcon}
                      x="8"
                      y="8"
                      width="20"
                      height="20"
                    />
                  </svg>
                </div>
                <div className="tile-font">
                  <span className="checkout-highlight">100,000+</span>{" "}
                  prescriptions written
                </div>
              </div>

              <div className="tile-styling">
                <div className="icon-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="36"
                    viewBox="0 0 35 36"
                    fill="none"
                  >
                    <circle
                      cx="17.5"
                      cy="18.1396"
                      r="17.25"
                      stroke="#AF71AF"
                      strokeWidth="0.5"
                    />
                    <image href={starIcon} x="8" y="8" width="20" height="20" />
                  </svg>
                </div>
                <div className="tile-font">
                  <span className="checkout-highlight">98%</span> success rate
                  from the Claya program
                </div>
              </div>

              <div className="tile-styling">
                <div className="icon-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="36"
                    viewBox="0 0 35 36"
                    fill="none"
                  >
                    <circle
                      cx="17.5"
                      cy="18.1396"
                      r="17.25"
                      stroke="#AF71AF"
                      strokeWidth="0.5"
                    />
                    <image
                      href={weightLossIcon}
                      x="8"
                      y="8"
                      width="20"
                      height="20"
                    />
                  </svg>
                </div>
                <div className="tile-font">
                  Ranked{" "}
                  <span className="checkout-highlight">#1 Weight Loss</span>{" "}
                  provider
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-container">
            <div
              className="review-container"
              ref={containerRef}
              style={{
                overflowX: "auto",
                overflowY: "hidden",
                display: "flex",
                flexDirection: "row",
                scrollBehavior: "smooth",
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {currentImages.map((image, index) => (
                <div className="review-item" key={index}>
                  <img src={image} alt={`Step ${start + index + 1}`} />
                </div>
              ))}
            </div>

            {/* Navigation Buttons */}
            <div className="scroll-indicator">
              <div className="arrow" onClick={goToPrevious}>
                <img
                  src={arrowLeft}
                  alt="Left Arrow"
                  style={{ width: "27px", height: "24px" }}
                />
              </div>

              {Array.from({
                length: Math.ceil(images.length / imagesPerView),
              }).map((_, index) => (
                <div
                  key={index}
                  className={`indicator-circle ${
                    currentIndex === index ? "active" : ""
                  }`}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}

              <div className="arrow" onClick={goToNext}>
                <img
                  src={arrowRight}
                  alt="Right Arrow"
                  style={{ width: "27px", height: "24px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage19;